import React, { useEffect, useState } from 'react';
import { useAdminStore } from '../../../lib/store-admin';
import { Simulation, Institution } from '../../../lib/supabase';
import { SimulationConfigEditor } from './SimulationConfigEditor';

export const SimulationManager: React.FC = () => {
    const { institutions, simulations, isLoading, fetchInstitutions, fetchSimulations, deleteSimulation, selectedInstitution, setSelectedInstitution } = useAdminStore();
    // const [selectedInstitution, setSelectedInstitution] = useState<Institution | null>(null); // Removed local state
    const [selectedSimulation, setSelectedSimulation] = useState<Simulation | undefined>(undefined);
    const [isEditorOpen, setIsEditorOpen] = useState(false);

    useEffect(() => {
        fetchInstitutions();
    }, [fetchInstitutions]);

    useEffect(() => {
        if (selectedInstitution) {
            fetchSimulations(selectedInstitution.id);
        }
    }, [selectedInstitution, fetchSimulations]);

    const handleInstitutionSelect = (inst: Institution) => {
        setSelectedInstitution(inst);
    };

    const handleBackToInstitutions = () => {
        setSelectedInstitution(null);
    };

    const handleCreateSimulation = () => {
        setSelectedSimulation(undefined);
        setIsEditorOpen(true);
    };

    const handleEditSimulation = (sim: Simulation) => {
        setSelectedSimulation(sim);
        setIsEditorOpen(true);
    };

    const handleDeleteSimulation = async (id: string, e: React.MouseEvent) => {
        e.stopPropagation();
        if (window.confirm('Bu simülasyonu silmek istediğinize emin misiniz?')) {
            await deleteSimulation(id);
            if (selectedInstitution) {
                fetchSimulations(selectedInstitution.id);
            }
        }
    };

    if (isEditorOpen && selectedInstitution) {
        return (
            <SimulationConfigEditor
                institutionId={selectedInstitution.id}
                simulation={selectedSimulation}
                onClose={() => {
                    setIsEditorOpen(false);
                    if (selectedInstitution) fetchSimulations(selectedInstitution.id);
                }}
            />
        );
    }

    if (!selectedInstitution) {
        return (
            <div className="simulation-manager-view">
                <h1>Simülasyon Kurum Seçimi</h1>
                <p>Simülasyonlarını yönetmek için bir kurum seçin.</p>
                <div className="institutions-grid">
                    {institutions.map((inst) => (
                        <div
                            key={inst.id}
                            className={`institution-card ${inst.is_active ? '' : 'inactive'}`}
                            onClick={() => handleInstitutionSelect(inst)}
                        >
                            <div className="logo-placeholder">
                                {inst.logo_url ? (
                                    <img src={inst.logo_url} alt={inst.name} />
                                ) : (
                                    <span className="material-symbols-outlined">apartment</span>
                                )}
                            </div>
                            <h3>{inst.name}</h3>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    // Selected Institution View
    return (
        <div className="simulation-list-view">
            <div className="action-bar js-sb">
                <div className="header-left">
                    <button className="btn-back" onClick={handleBackToInstitutions}>
                        <span className="material-symbols-outlined">arrow_back</span>
                    </button>
                    <div>
                        <h1>{selectedInstitution.name} Simülasyonları</h1>
                        <p>Bu kurum için oluşturulmuş simülasyonlar.</p>
                    </div>
                </div>
                <button className="btn-primary" onClick={handleCreateSimulation}>
                    <span className="material-symbols-outlined">add</span>
                    Yeni Simülasyon
                </button>
            </div>

            {isLoading && <div className="loading-spinner">Yükleniyor...</div>}

            <div className="simulations-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px', marginTop: '24px' }}>
                {simulations.length === 0 && !isLoading && (
                    <div className="empty-state">Henüz simülasyon oluşturulmamış.</div>
                )}

                {simulations.map((sim) => (
                    <div
                        key={sim.id}
                        className="content-card simulation-card"
                        style={{ cursor: 'pointer', transition: 'transform 0.2s', borderLeft: '4px solid #9240ff' }}
                        onClick={() => handleEditSimulation(sim)}
                    >
                        <h3>{sim.title}</h3>
                        <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '16px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                            {sim.description || 'Açıklama yok'}
                        </p>

                        <div className="card-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto' }}>
                            <span className={`status-badge ${sim.is_active ? 'active' : 'inactive'}`} style={{ fontSize: '12px', padding: '2px 8px', borderRadius: '4px', background: sim.is_active ? '#d1fae5' : '#f3f4f6', color: sim.is_active ? '#065f46' : '#4b5563' }}>
                                {sim.is_active ? 'Aktif' : 'Pasif'}
                            </span>

                            <button
                                onClick={(e) => handleDeleteSimulation(sim.id, e)}
                                style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', padding: '4px' }}
                            >
                                <span className="material-symbols-outlined">delete</span>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
